import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { PaymentService } from '../../service/payment.service';
import { PaymentSlipDialog } from '../payment-slip/payment-slip.component';
import { SharedService } from '@shared/services/shared.service';
import { IPaymentType } from '../../models/payment-type';

@Component({
  selector: 'app-payment-notice',
  templateUrl: './payment-notice.html'
})

export class PaymentNoticeComponent {
  @Input() canPay: boolean = false;
  @Input() entityType: string = '';
  @Input() sku: string = '';
  @Input() feeType: string = this.paymentService.applicationFeeType;
  @Input() id: number = 0;
  @Input() cardColor: string = '';

  public paymentType: IPaymentType =
  {
    paymentTypeId: '',
    licenseTypeId: '',
    licenseSubTypeId: '',
    name: '',
    description: '',
    value: '',
    active: false,
    createdDate: new Date(),
    modifiedDate: new Date()
  };
  public paymentAmount: string = '';
  staffInbox = environment.staffInbox;
  constructor(public paymentService: PaymentService,
    public sharedService: SharedService,
    public router: Router,
    public dialog: MatDialog) { }

  pay() {
    this.dialog.closeAll();
    this.router.navigate(['/pay-online/' + this.id], { queryParams: { entityType: this.entityType } });
  }

  viewRemittanceSlip() {
    this.dialog.open(PaymentSlipDialog, {
      data: {
        sku: this.sku,
        feeType: this.feeType,
        entityType: this.entityType,
        id: this.id
      },
      role: 'dialog',
      ariaLabel: 'Remittance Slip Dialog',
      minWidth: !this.sharedService.mobile ? '400px' : '300px',
      maxWidth: !this.sharedService.mobile ? '800px' : '300px'
    });
  }
}
